import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const ActivityIndicatorElementFields = {
  group: ELEMENT_GROUPS.OTHER,
  label: 'Activity Indicator',
  icon: 'DocumentTextIcon',
  description: 'Adds an activity indicator',
  properties: [
    'layout',
    'color',
    'alignment',
    'margin',
    'padding',
    {
      label: 'Height',
      name: 'height',
      editor: 'number',
      description: 'The height of the text block',
      default: 45,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    }
  ]
};

export default ActivityIndicatorElementFields;
